"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

var supportAgent = function supportAgent() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_3854_13205)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_3854_13205",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "25",
    height: "24"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0.5",
    width: "24",
    height: "24",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_3854_13205)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.8846 20.5V19H19.1923C19.2756 19 19.3477 18.9743 19.4086 18.9231C19.4695 18.8718 19.5 18.8045 19.5 18.7211V11.7269C19.5 9.81534 18.816 8.20605 17.4481 6.899C16.0801 5.59197 14.4307 4.93845 12.5 4.93845C10.5692 4.93845 8.91985 5.59197 7.5519 6.899C6.18395 8.20605 5.49998 9.81534 5.49998 11.7269V17.6153H4.75C4.27052 17.6153 3.85898 17.4483 3.5154 17.1144C3.1718 16.7804 3 16.3737 3 15.8942V13.9519C3 13.6275 3.09231 13.3304 3.27693 13.0606C3.46154 12.7907 3.70257 12.5737 4 12.4096L4.04618 11.1327C4.12821 10.0442 4.41089 9.0359 4.89423 8.1077C5.37756 7.17948 5.99743 6.37147 6.75383 5.68365C7.51024 4.99583 8.38332 4.45994 9.37305 4.07598C10.3628 3.69199 11.4051 3.5 12.5 3.5C13.5948 3.5 14.6346 3.69199 15.6192 4.07598C16.6038 4.45994 17.4769 4.99328 18.2384 5.67598C19 6.35866 19.6198 7.1641 20.098 8.0923C20.5762 9.0205 20.8615 10.0288 20.9538 11.1173L21 12.3692C21.291 12.5064 21.5304 12.7025 21.7182 12.9577C21.906 13.2128 22 13.4974 22 13.8115V16.0442C22 16.3583 21.906 16.6429 21.7182 16.898C21.5304 17.1532 21.291 17.3493 21 17.4865V18.7211C21 19.2134 20.8233 19.633 20.4701 19.9798C20.1169 20.3266 19.691 20.5 19.1923 20.5H11.8846ZM9.6923 13.7692C9.44743 13.7692 9.23878 13.6862 9.06635 13.5202C8.89392 13.3541 8.8077 13.1487 8.8077 12.9038C8.8077 12.6589 8.89392 12.4519 9.06635 12.2827C9.23878 12.1134 9.44743 12.0288 9.6923 12.0288C9.93717 12.0288 10.1458 12.1134 10.3183 12.2827C10.4907 12.4519 10.5769 12.6589 10.5769 12.9038C10.5769 13.1487 10.4907 13.3541 10.3183 13.5202C10.1458 13.6862 9.93717 13.7692 9.6923 13.7692ZM15.3077 13.7692C15.0628 13.7692 14.8541 13.6862 14.6817 13.5202C14.5093 13.3541 14.423 13.1487 14.423 12.9038C14.423 12.6589 14.5093 12.4519 14.6817 12.2827C14.8541 12.1134 15.0628 12.0288 15.3077 12.0288C15.5525 12.0288 15.7612 12.1134 15.9336 12.2827C16.106 12.4519 16.1923 12.6589 16.1923 12.9038C16.1923 13.1487 16.106 13.3541 15.9336 13.5202C15.7612 13.6862 15.5525 13.7692 15.3077 13.7692ZM6.87115 12.2C6.7673 10.5679 7.27499 9.17145 8.39423 8.01055C9.51346 6.84967 10.8987 6.26923 12.55 6.26923C13.9371 6.26923 15.1612 6.69839 16.2221 7.55673C17.283 8.41504 17.9269 9.52625 18.1538 10.8904C16.7333 10.8737 15.4208 10.5006 14.2163 9.77113C13.0118 9.04164 12.0872 8.04165 11.4423 6.77115C11.1885 8.01473 10.6564 9.11408 9.84615 10.0692C9.03588 11.0243 8.04422 11.7346 6.87115 12.2Z",
    fill: "#212124"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3854_13205"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0.5)"
  }))));
};
var _default = supportAgent;
exports.default = _default;